<template>
  <div class="sideBar">
    <span class="circle"></span>
    <span class="sideBarTitle">{{title}}</span>
  </div>
</template>

<script>
export default {
  name: "sideBar",
  props:{
    title:String
  },
  methods:{
    back(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>
<style lang="less">
  .sideBar{
    padding:13px 0;
    .circle{
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #65A1FF;
      margin-right: 8px;
      vertical-align: middle;
    }
    .sideBarTitle{
      color: #000000;
      font-size: 14px;
      vertical-align: middle;
      font-weight: bold;
    }
  }
  
</style>




// WEBPACK FOOTER //
// src/components/sideBar.vue